const map = {
	"./AD.svg": 2580,
	"./AE.svg": 40565,
	"./AF.svg": 3926,
	"./AG.svg": 67143,
	"./AI.svg": 61345,
	"./AL.svg": 78044,
	"./AM.svg": 6589,
	"./AO.svg": 80367,
	"./AQ.svg": 79081,
	"./AR.svg": 34266,
	"./AS.svg": 28139,
	"./AT.svg": 44196,
	"./AU.svg": 41445,
	"./AW.svg": 98647,
	"./AX.svg": 62816,
	"./AZ.svg": 20098,
	"./BA.svg": 66448,
	"./BB.svg": 48899,
	"./BD.svg": 33437,
	"./BE.svg": 4892,
	"./BF.svg": 83919,
	"./BG.svg": 21342,
	"./BH.svg": 91161,
	"./BI.svg": 25768,
	"./BJ.svg": 7131,
	"./BL.svg": 36789,
	"./BM.svg": 75508,
	"./BN.svg": 63367,
	"./BO.svg": 23830,
	"./BQ.svg": 47136,
	"./BR.svg": 54227,
	"./BS.svg": 23650,
	"./BT.svg": 32941,
	"./BV.svg": 76511,
	"./BW.svg": 38574,
	"./BY.svg": 73624,
	"./BZ.svg": 12459,
	"./CA.svg": 44935,
	"./CC.svg": 99061,
	"./CD.svg": 88650,
	"./CF.svg": 25128,
	"./CG.svg": 49401,
	"./CH.svg": 71678,
	"./CI.svg": 34255,
	"./CK.svg": 9501,
	"./CL.svg": 75570,
	"./CM.svg": 29859,
	"./CN.svg": 68368,
	"./CO.svg": 80609,
	"./CR.svg": 49668,
	"./CU.svg": 11819,
	"./CV.svg": 72984,
	"./CW.svg": 7849,
	"./CX.svg": 71118,
	"./CY.svg": 75871,
	"./CZ.svg": 20524,
	"./DE.svg": 57298,
	"./DJ.svg": 11413,
	"./DK.svg": 38804,
	"./DM.svg": 4554,
	"./DO.svg": 14184,
	"./DZ.svg": 16741,
	"./EC.svg": 74815,
	"./EE.svg": 44881,
	"./EG.svg": 29683,
	"./EH.svg": 17988,
	"./ER.svg": 89470,
	"./ES-CT.svg": 11373,
	"./ES.svg": 33199,
	"./ET.svg": 67312,
	"./EU.svg": 2849,
	"./FI.svg": 68380,
	"./FJ.svg": 70703,
	"./FK.svg": 34302,
	"./FM.svg": 60560,
	"./FO.svg": 62994,
	"./FR.svg": 88983,
	"./GA.svg": 70891,
	"./GB-NIR.svg": 23028,
	"./GB.svg": 12824,
	"./GD.svg": 52422,
	"./GE.svg": 57751,
	"./GF.svg": 86948,
	"./GG.svg": 84197,
	"./GH.svg": 62850,
	"./GI.svg": 50227,
	"./GL.svg": 8398,
	"./GM.svg": 23039,
	"./GN.svg": 44012,
	"./GP.svg": 54218,
	"./GQ.svg": 23035,
	"./GR.svg": 91144,
	"./GS.svg": 3513,
	"./GT.svg": 46678,
	"./GU.svg": 9895,
	"./GW.svg": 83317,
	"./GY.svg": 18723,
	"./HK.svg": 58056,
	"./HM.svg": 13590,
	"./HN.svg": 50229,
	"./HR.svg": 86865,
	"./HT.svg": 89951,
	"./HU.svg": 58958,
	"./ID.svg": 63340,
	"./IE.svg": 10701,
	"./IL.svg": 6276,
	"./IM.svg": 3525,
	"./IN.svg": 71750,
	"./IO.svg": 77079,
	"./IQ.svg": 23425,
	"./IR.svg": 34738,
	"./IS.svg": 38051,
	"./IT.svg": 40124,
	"./JE.svg": 83092,
	"./JM.svg": 64892,
	"./JO.svg": 81342,
	"./JP.svg": 17513,
	"./KE.svg": 50291,
	"./KG.svg": 42193,
	"./KH.svg": 67334,
	"./KI.svg": 54871,
	"./KM.svg": 73899,
	"./KN.svg": 35064,
	"./KP.svg": 33758,
	"./KR.svg": 17308,
	"./KW.svg": 42689,
	"./KY.svg": 7015,
	"./KZ.svg": 35508,
	"./LA.svg": 81078,
	"./LB.svg": 94037,
	"./LC.svg": 32756,
	"./LI.svg": 78590,
	"./LK.svg": 62140,
	"./LR.svg": 99365,
	"./LS.svg": 21348,
	"./LT.svg": 69707,
	"./LU.svg": 64442,
	"./LV.svg": 6377,
	"./LY.svg": 95822,
	"./MA.svg": 51781,
	"./MC.svg": 78359,
	"./MD.svg": 83288,
	"./ME.svg": 58793,
	"./MF.svg": 16858,
	"./MG.svg": 22123,
	"./MH.svg": 7148,
	"./MK.svg": 86175,
	"./ML.svg": 56800,
	"./MM.svg": 13713,
	"./MN.svg": 33314,
	"./MO.svg": 63891,
	"./MP.svg": 85172,
	"./MQ.svg": 46453,
	"./MR.svg": 33494,
	"./MS.svg": 73031,
	"./MT.svg": 35432,
	"./MU.svg": 825,
	"./MV.svg": 74826,
	"./MW.svg": 16795,
	"./MX.svg": 14556,
	"./MY.svg": 43101,
	"./MZ.svg": 31006,
	"./NA.svg": 53676,
	"./NC.svg": 18062,
	"./NE.svg": 15232,
	"./NF.svg": 59891,
	"./NG.svg": 72514,
	"./NI.svg": 96612,
	"./NL.svg": 31497,
	"./NO.svg": 86682,
	"./NP.svg": 59005,
	"./NR.svg": 32783,
	"./NU.svg": 22640,
	"./NZ.svg": 19559,
	"./OM.svg": 13031,
	"./PA.svg": 45834,
	"./PE.svg": 4502,
	"./PF.svg": 17461,
	"./PG.svg": 56180,
	"./PH.svg": 29571,
	"./PK.svg": 47120,
	"./PL.svg": 64591,
	"./PM.svg": 2014,
	"./PN.svg": 14109,
	"./PR.svg": 29801,
	"./PS.svg": 31915,
	"./PT.svg": 49367,
	"./PW.svg": 44772,
	"./PY.svg": 4322,
	"./QA.svg": 82217,
	"./RE.svg": 77100,
	"./RO.svg": 85510,
	"./RS.svg": 48498,
	"./RU.svg": 53884,
	"./RW.svg": 36158,
	"./SA.svg": 41783,
	"./SB.svg": 98660,
	"./SC.svg": 49829,
	"./SD.svg": 88730,
	"./SE.svg": 3339,
	"./SG.svg": 56841,
	"./SH.svg": 27054,
	"./SI.svg": 55487,
	"./SJ.svg": 76460,
	"./SK.svg": 75405,
	"./SL.svg": 5186,
	"./SM.svg": 10355,
	"./SN.svg": 89600,
	"./SO.svg": 25553,
	"./SR.svg": 71892,
	"./SS.svg": 44501,
	"./ST.svg": 37642,
	"./SV.svg": 47272,
	"./SX.svg": 70142,
	"./SY.svg": 13871,
	"./SZ.svg": 34844,
	"./TC.svg": 96364,
	"./TD.svg": 64051,
	"./TF.svg": 55953,
	"./TG.svg": 9504,
	"./TH.svg": 68631,
	"./TJ.svg": 96581,
	"./TK.svg": 41860,
	"./TL.svg": 4011,
	"./TM.svg": 84954,
	"./TN.svg": 83689,
	"./TO.svg": 48824,
	"./TR.svg": 1693,
	"./TT.svg": 5699,
	"./TV.svg": 56449,
	"./TW.svg": 44208,
	"./TZ.svg": 74901,
	"./UA.svg": 30013,
	"./UG.svg": 99395,
	"./UM.svg": 84185,
	"./UN.svg": 34890,
	"./US.svg": 3711,
	"./UY.svg": 64869,
	"./UZ.svg": 33094,
	"./VA.svg": 87524,
	"./VC.svg": 29318,
	"./VE.svg": 97048,
	"./VG.svg": 30618,
	"./VI.svg": 20908,
	"./VN.svg": 77651,
	"./VU.svg": 49192,
	"./WF.svg": 96852,
	"./WS.svg": 31273,
	"./YE.svg": 68605,
	"./YT.svg": 63276,
	"./ZA.svg": 62264,
	"./ZM.svg": 86124,
	"./ZW.svg": 82294,
	"./_england.svg": 86601,
	"./_scotland.svg": 70338,
	"./_unknown.svg": 31904,
	"./_wales.svg": 92686
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 17505;